import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import config from "../../env.json";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../app/slice/sideBarSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Sidebar({ permissions }: { permissions: any[] }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeTab = useSelector((state: any) => state.sideBar.active);

  const [menuList, setMenuList] = useState<any[]>([]);
  const [activeClass, setActiveClass] = useState("");

  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const EnvId = useSelector((state: any) => state.userPermisssion.env);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );

  const [menuData, setMenuData] = useState<any[]>([]);

  useEffect(() => {
    try {
      const filtered = permissions.filter(
        (item: any) => item.Permission_Typ === "Module"
      );

      const unique = Array.from(
        new Map(filtered.map((item: any) => [item.Permission_Id, item])).values()
      );

      const sorted = unique
      .filter((item: any) => Number(item.DisplayOrder_Nbr) > 0)
      .sort(
        (a: any, b: any) =>
          Number(a.DisplayOrder_Nbr) - Number(b.DisplayOrder_Nbr)
      );

      const mappedMenu = sorted.map((item: any, index: number) => ({
        PermissionsId: item.Permission_Id,
        Permissions_Nm: item.SystemAdminPermissions_Nm,
        Display_Nm: item.Display_Nm,
        Display_Or: index + 1,
        ClassNameForUI: item.IconStoredUrl_Loc,
        disabled: item.Read_Flg !== "Y"
      }));

      setMenuData(mappedMenu);
    } catch (err) {
      console.error(err);
    }
  }, [permissions]);

  useEffect(() => {
    setMenuList(menuData);

    if (menuData.length > 0) {
      if (!activeTab) {
        handleMenuItemClick(menuData[0]);
      } else {
        setActiveClass(activeTab);
      }
    }
  }, [menuData]);

  const handleMenuItemClick = (item: any) => {
    setActiveClass(item.PermissionsId);
    dispatch(setActiveTab(item.PermissionsId));
  };

  const { t } = useTranslation();

  return (
    <div className="sidebar-container notMobile">
      <div className="zing-logo-div">
        <div className="logo-img">
          <img src={config.REACT_APP_LOGO} alt="Zing Logo" />
        </div>
      </div>

      <div className="menu-btn-div">
        <ul>
          {menuList?.map((items) => {
            return (
              <Link
                key={items.PermissionsId}
                className={
                  activeClass === items.PermissionsId
                    ? "active"
                    : items.disabled
                    ? "disbaled"
                    : ""
                }
                onClick={(e) => {
                  if (!items.disabled) handleMenuItemClick(items);
                  else e.preventDefault();
                }}
                to={"/" + items.Permissions_Nm.replace(/ /g, "")}
              >
                <FontAwesomeIcon icon={items.ClassNameForUI} />
                <h3>{t(items.Display_Nm)}</h3>
              </Link>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;